import classNames from 'classnames';
import {FC} from 'react';

import {ReactComponent as AccountIcon} from './svg/account.svg';
import {ReactComponent as AddIcon} from './svg/add.svg';
import {ReactComponent as Advantage1Icon} from './svg/adv1.svg';
import {ReactComponent as Advantage1DarkIcon} from './svg/adv1Dark.svg';
import {ReactComponent as Advantage2Icon} from './svg/adv2.svg';
import {ReactComponent as Advantage2DarkIcon} from './svg/adv2Dark.svg';
import {ReactComponent as Advantage3Icon} from './svg/adv3.svg';
import {ReactComponent as Advantage3DarkIcon} from './svg/adv3Dark.svg';
import {ReactComponent as Advantage4Icon} from './svg/adv4.svg';
import {ReactComponent as Advantage4DarkIcon} from './svg/adv4Dark.svg';
import {ReactComponent as ArrowIcon} from './svg/arrow.svg';
import {ReactComponent as AttachmentIcon} from './svg/attachment.svg';
import {ReactComponent as BackIcon} from './svg/back.svg';
import {ReactComponent as BankIcon} from './svg/bank.svg';
import {ReactComponent as CardIcon} from './svg/card.svg';
import {ReactComponent as CartIcon} from './svg/cart.svg';
import {ReactComponent as BreadIcon} from './svg/categories/bread.svg';
import {ReactComponent as EquipmentIcon} from './svg/categories/equipment.svg';
import {ReactComponent as FurnitureIcon} from './svg/categories/furniture.svg';
import {ReactComponent as InventoryIcon} from './svg/categories/inventory.svg';
import {ReactComponent as CookwareIcon} from './svg/categories/tableware.svg';
import {ReactComponent as CoinIcon} from './svg/coin.svg';
import {ReactComponent as CompanyIcon} from './svg/company.svg';
import {ReactComponent as CopyIcon} from './svg/copy.svg';
import {ReactComponent as Cross14Icon} from './svg/cross14.svg';
import {ReactComponent as CrossIcon} from './svg/cross.svg';
import {ReactComponent as DeleteIcon} from './svg/delete.svg';
import {ReactComponent as DeliveryCarSaleIcon} from './svg/deliveryCarSale.svg';
import {ReactComponent as DiscountIcon} from './svg/discount.svg';
import {ReactComponent as DocIcon} from './svg/doc.svg';
import {ReactComponent as DocFillIcon} from './svg/docFill.svg';
import {ReactComponent as DownloadIcon} from './svg/download.svg';
import {ReactComponent as EditIcon} from './svg/edit.svg';
import {ReactComponent as EmailIcon} from './svg/email.svg';
import {ReactComponent as EntranceIcon} from './svg/entrance.svg';
import {ReactComponent as ExitIcon} from './svg/exit.svg';
import {ReactComponent as FavoriteIcon} from './svg/favorite.svg';
import {ReactComponent as FavoriteActiveIcon} from './svg/favoriteActive.svg';
import {ReactComponent as InfoFilledIcon} from './svg/filled/info.svg';
import {ReactComponent as ForwardIcon} from './svg/forward.svg';
import {ReactComponent as HeaderCatalogIcon} from './svg/header/catalog.svg';
import {ReactComponent as HomeIcon} from './svg/home.svg';
import {ReactComponent as Info19Icon} from './svg/info19.svg';
import {ReactComponent as InfoIcon} from './svg/info.svg';
import {ReactComponent as LocationIcon} from './svg/location.svg';
import {ReactComponent as LocationPlusIcon} from './svg/locationPlus.svg';
import {ReactComponent as LocationsIcon} from './svg/locations.svg';
import {ReactComponent as MetroIcon} from './svg/metro.svg';
import {ReactComponent as MinusIcon} from './svg/minus.svg';
import {ReactComponent as OrderIcon} from './svg/order.svg';
import {ReactComponent as PhoneIcon} from './svg/phone.svg';
import {ReactComponent as Plus12Icon} from './svg/plus12.svg';
import {ReactComponent as PlusIcon} from './svg/plus.svg';
import {ReactComponent as SettingsIcon} from './svg/settings.svg';
import {ReactComponent as SuccessIcon} from './svg/success.svg';
import {ReactComponent as SupportQuestionIcon} from './svg/supportQuestion.svg';

const mapNameToComponent = {
    account: AccountIcon,
    company: CompanyIcon,
    advantage1: Advantage1Icon,
    advantage2: Advantage2Icon,
    advantage3: Advantage3Icon,
    advantage4: Advantage4Icon,
    advantage1Dark: Advantage1DarkIcon,
    advantage2Dark: Advantage2DarkIcon,
    advantage3Dark: Advantage3DarkIcon,
    advantage4Dark: Advantage4DarkIcon,
    home: HomeIcon,
    order: OrderIcon,
    discount: DiscountIcon,
    locations: LocationsIcon,
    settings: SettingsIcon,
    phone: PhoneIcon,
    email: EmailIcon,
    back: BackIcon,
    copy: CopyIcon,
    location: LocationIcon,
    edit: EditIcon,
    delete: DeleteIcon,
    doc: DocIcon,
    arrow: ArrowIcon,
    download: DownloadIcon,
    forward: ForwardIcon,
    cross: CrossIcon,
    cross14: Cross14Icon,
    attachment: AttachmentIcon,
    exit: ExitIcon,
    entrance: EntranceIcon,
    success: SuccessIcon,
    supportQuestion: SupportQuestionIcon,
    plus: PlusIcon,
    plus12: Plus12Icon,
    minus: MinusIcon,
    add: AddIcon,
    favorite: FavoriteIcon,
    cart: CartIcon,
    deliveryCarSale: DeliveryCarSaleIcon,
    coin: CoinIcon,
    bank: BankIcon,
    card: CardIcon,
    docFill: DocFillIcon,
    metro: MetroIcon,
    bread: BreadIcon,
    favoriteActive: FavoriteActiveIcon,
    info: InfoIcon,
    info19: Info19Icon,
    locationPlus: LocationPlusIcon,
    headerCatalog: HeaderCatalogIcon,
    inventory: InventoryIcon,
    cookware: CookwareIcon,
    equipment: EquipmentIcon,
    furniture: FurnitureIcon,
    infoFilled: InfoFilledIcon,
};

type Props = {
    className?: string;
    onClick?: () => void;
    onMouseDown?: () => void;
    onMouseEnter?: () => void;
    onMouseLeave?: () => void;
    name: keyof typeof mapNameToComponent;
};
export const Icon: FC<Props> = ({
    name,
    className,
    onClick,
    onMouseDown,
    onMouseEnter,
    onMouseLeave,
}) => {
    const IconComponent = mapNameToComponent[name];
    return (
        <IconComponent
            onClick={onClick}
            className={classNames(className, '-no-restyle')}
            onMouseDown={onMouseDown}
            onMouseEnter={onMouseEnter}
            onMouseLeave={onMouseLeave}
        />
    );
};
